import { render, staticRenderFns } from "./HomeBlock.vue?vue&type=template&id=34ab4eeb&"
import script from "./HomeBlock.vue?vue&type=script&lang=js&"
export * from "./HomeBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports